import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { CLA_SETTINGS_FLAG } from '../types';

import { isFieldInArrayValueGetter } from 'components/shared/DataGrid/utils/valueGetters/isFieldInArrayValueGetter';

import {
  GridColDef,
  GridColumns,
  GridValidRowModel
} from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useColumnDefinitions = (): GridColDef[] => {
  const { t } = useTranslation('common', { keyPrefix: 'adminPortal.cla' });

  return useMemo<GridColumns<GridValidRowModel>>(
    () => [
      {
        field: 'code',
        headerName: t('code'),
        type: 'string',
        hideable: false,
        flex: 1,
        align: 'left'
      },
      {
        field: 'description',
        headerName: t('description'),
        type: 'string',
        flex: 1,
        align: 'left'
      },
      {
        field: 'year',
        headerName: t('year'),
        type: 'string',
        align: 'left',
        flex: 1
      },
      {
        field: 'hoursWorkingPerYear',
        headerName: t('yearHours'),
        type: 'number',
        flex: 1,
        align: 'left'
      },
      {
        field: 'periodHours',
        headerName: t('periodHours'),
        type: 'number',
        flex: 1,
        align: 'left'
      },
      {
        field: 'hoursHolidayPerYear',
        headerName: t('leave'),
        type: 'number',
        align: 'left',
        flex: 1
      },
      {
        field: 'hoursWorkingPerWeek',
        headerName: t('weekHours'),
        type: 'number',
        flex: 1,
        align: 'left'
      },
      {
        field: 'hoursWorkingPerDay',
        headerName: t('dayHours'),
        type: 'number',
        flex: 1,
        align: 'left'
      },
      {
        field: 'LEAVE_HOURS_EQUAL_PERIODS' as CLA_SETTINGS_FLAG,
        type: 'boolean',
        headerName: t('leaveEqualPeriods'),
        flex: 1,
        align: 'left',
        valueGetter: isFieldInArrayValueGetter('flags'),
        renderCell: ({ value }) => <BooleanCell value={value} />
      },
      {
        field: 'leaveHoursBasedOnWork',
        type: 'boolean',
        flex: 1,
        align: 'left',
        headerName: t('leaveBasedOnWork'),
        renderCell: BooleanCell
      }
    ],
    []
  );
};
